// import { setLoading } from "@/redux/slice/loading";
import { errorToast } from "./toast";

export const baseURL = `${process.env.BASE_URL}api`;

const publicApiCall = {

    async get(url, dispatch) {
        document.getElementById('overlay').style.display = 'block';
        return fetch(`${baseURL}/${url}`)
            .then(async (response) => {
                document.getElementById('overlay').style.display = 'none';
                if (!response.ok) {
                    if (dispatch !== undefined) {
                        dispatch(setLoading(false));
                    }

                    const error = await response.json();
                    errorToast(error.message);
                    return await Promise.reject(error);
                } else {
                    if (dispatch !== undefined) {
                        dispatch(setLoading(true));
                    }
                }

                return response.json();
            })
            .catch((error) => {
                if (dispatch !== undefined) {
                    dispatch(setLoading(false));
                }
                errorToast('An error occurred while making the request.');
                return Promise.reject(error);
            });
    },

    // async post(url, data, dispatch) {
    //     document.getElementById('overlay').style.display = 'block';
    //      fetch(`${baseURL}/${url}`, {
    //         method: 'POST',
    //         body: JSON.stringify(data),
    //     })
    //         .then(async (response) => {
    //             document.getElementById('overlay').style.display = 'none';
    //             if (!response.ok) {
    //                // dispatch();
    //                 const error = await response.json();
    //                 errorToast(error.message);
    //                 return await Promise.reject(error);
    //             } else {
    //                // dispatch();
    //             }
    //   alert("response is"+response.json());
    //             return response.json();
    //         })
    //         .catch((error) => {
    //            // dispatch();
    //             errorToast('An error occurred while making the request.');
    //             return Promise.reject(error);
    //         });
    // },
    async post(url, data, dispatch) {
        document.getElementById('overlay').style.display = 'block';
    
        try {
            const response = await fetch(`${baseURL}/${url}`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                },
            });
    
            document.getElementById('overlay').style.display = 'none';
    
            if (!response.ok) {
                const error = await response.json();
                // Dispatch your error action if using Redux
                // dispatch();
                errorToast(error.message);
                return Promise.reject(error);
            }
    
            // Dispatch your success action if using Redux
            // dispatch();
    
            const responseData = await response.json();
            console.log('Response data:', responseData);
    
            return responseData;
        } catch (error) {
            // Dispatch your error action if using Redux
            // dispatch();
            console.error('An error occurred while making the request:', error);
            errorToast('An error occurred while making the request.');
            return Promise.reject(error);
        }
    }
    
};

export default publicApiCall;
